function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useCallback, useContext, useMemo } from 'react';
import styles from './RecordComparePropertyTitle.module.scss';
import I18n from '../../../I18n/I18n/I18n';
import LabelIcons from '../../../SchemaForm/LabelIcons/LabelIcons';
import HelpTemplate from '../../../SchemaForm/HelpTemplate/HelpTemplate';
import getOr from '../../../utils/getOr';
import CompareContext from './RecordCompareContext';
import RecordCompareStateContext from '../../RecordCompareStateContext';
import { getColumnId, getRowId } from '../../util/recordCompareAria';
var getIcons = getOr([])('ui:options.icons');
var getTitle = getOr({})('ui:title');
var getRequired = getOr([])('required');
var getHelp = getOr(null)('ui:help');
var ARROW_RIGHT = 'ArrowRight';
var ARROW_LEFT = 'ArrowLeft';
var ARROW_DOWN = 'ArrowDown';
var ARROW_UP = 'ArrowUp';
export default function (_ref) {
  var _ref$help = _ref.help,
    help = _ref$help === void 0 ? true : _ref$help,
    _ref$icons = _ref.icons,
    icons = _ref$icons === void 0 ? true : _ref$icons,
    property = _ref.property,
    _ref$recordIndex = _ref.recordIndex,
    recordIndex = _ref$recordIndex === void 0 ? null : _ref$recordIndex,
    _ref$labelFor = _ref.labelFor,
    labelFor = _ref$labelFor === void 0 ? '' : _ref$labelFor,
    _ref$handleChange = _ref.handleChange,
    handleChange = _ref$handleChange === void 0 ? function () {} : _ref$handleChange,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error;
  var _useContext = useContext(CompareContext),
    mergeRecord = _useContext.mergeRecord,
    groupName = _useContext.groupName;
  var _useContext2 = useContext(RecordCompareStateContext),
    cardView = _useContext2.cardView,
    records = _useContext2.records;
  var schema = mergeRecord.schema,
    uiSchema = mergeRecord.uiSchema;
  var propUiSchema = uiSchema[property];
  var _help = useMemo(function () {
    var help = getHelp(propUiSchema);
    if (help) {
      return {
        i18n: {
          id: help.text
        },
        escape: help.escape
      };
    }
    return null;
  }, [propUiSchema]);
  var _getTitle = getTitle(propUiSchema),
    text = _getTitle.text,
    escape = _getTitle.escape;
  var _icons = useMemo(function () {
    var icons = _toConsumableArray(getIcons(propUiSchema));
    var required = getRequired(schema);
    if (required.indexOf(property) !== -1) {
      icons.push('REQUIRED');
    }
    return icons;
  }, [propUiSchema, schema, property]);
  var tag = useMemo(function () {
    if (!recordIndex) {
      // 0 is "reference" value | null | undefined
      return null;
    }
    var refValue = records[0].data[property];
    var thisValue = records[recordIndex].data[property];
    if (thisValue === null ||
    // thisValue === undefined ||
    refValue === thisValue || typeof thisValue === 'object' || typeof refValue === 'object') {
      return null;
    }
    return refValue === null || refValue === undefined ? 'new' : 'different';
  }, [property, recordIndex, records]);
  var handleKeyDown = useCallback(function (event) {
    if (event.key === ARROW_RIGHT || event.key === ARROW_UP) {
      event.stopPropagation();
      event.preventDefault();
      var radioButtons = document.querySelectorAll("input[name=\"".concat(property, "\"]"));
      if (recordIndex < radioButtons.length - 1) {
        radioButtons.item(recordIndex + 1).focus();
      } else {
        radioButtons.item(0).focus();
      }
    } else if (event.key === ARROW_LEFT || event.key === ARROW_DOWN) {
      event.stopPropagation();
      event.preventDefault();
      var _radioButtons = document.querySelectorAll("input[name=\"".concat(property, "\"]"));
      if (recordIndex !== 0) {
        _radioButtons.item(recordIndex - 1).focus();
      } else {
        _radioButtons.item(_radioButtons.length - 1).focus();
      }
    }
  }, [property, recordIndex]);
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.title, "\n\t\t\t").concat(cardView ? styles['card-view'] : '', "\n\t\t\tauto-title auto-title-").concat(property, "-").concat(recordIndex, "\n\t\t\t")
  }, readOnly && cardView && groupName && "".concat(groupName, " - "), cardView && !readOnly ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    id: labelFor,
    type: "radio",
    checked: checked,
    name: "".concat(property),
    value: "".concat(cardView && groupName ? "".concat(groupName, " - ") : '').concat(text),
    onChange: handleChange,
    className: styles.radio,
    "aria-disabled": "false",
    "aria-describedby": "".concat(getColumnId(recordIndex), " ").concat(getRowId(property)).concat(error ? " ".concat(labelFor, "-error") : ''),
    "aria-invalid": error,
    "aria-labelledby": "".concat(labelFor, "-label ").concat(labelFor, "-description"),
    onKeyDown: handleKeyDown,
    "aria-required": required
  }), /*#__PURE__*/React.createElement("label", {
    id: "".concat(labelFor, "-label"),
    htmlFor: labelFor,
    className: styles.label
  }, "".concat(groupName ? "".concat(groupName, " - ") : '').concat(text), required ? /*#__PURE__*/React.createElement("span", {
    className: styles.required
  }) : null, error ? /*#__PURE__*/React.createElement("span", {
    className: styles.error
  }) : null, cardView && tag && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement("span", {
    className: styles["tag-".concat(tag)]
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.record-compare.labels.tag-".concat(tag)
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(I18n, {
    i18n: text,
    escape: escape
  }), required ? /*#__PURE__*/React.createElement("span", {
    className: styles.required
  }) : null, error ? /*#__PURE__*/React.createElement("span", {
    className: styles.error
  }) : null), !cardView && icons && /*#__PURE__*/React.createElement(LabelIcons, {
    icons: _icons
  }), !cardView && help && /*#__PURE__*/React.createElement(HelpTemplate, {
    description: _help,
    i18n: text
  }));
}